import { useEffect, useState } from 'react'

let show: ((msg: string) => void) | null = null
export function toast(msg: string) { show?.(msg) }

export function Toaster() {
  const [msg, setMsg] = useState<string | null>(null)
  useEffect(() => {
    show = (m) => { setMsg(m); setTimeout(() => setMsg(null), 2600) }
    return () => { show = null }
  }, [])
  return msg ? <div className="toast" role="status" data-testid="toast">{msg}</div> : null
}
